import React, { useState } from 'react'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/themes/material_blue.css'
import { useTranslation } from 'react-i18next'
function ODatePicker ({
  handleDateChange,
  value,
  placeholder,
  handleAuctionStartDate,
  handleAuctionEndDate
}) {
  const [date, setDate] = useState(value ? value : '')
  const { t } = useTranslation()
  const onChange = ([date]) => {
    setDate(date)
    if (placeholder === t('O_AUCTION_START_DATE')) {
      handleAuctionStartDate(date)
    } else if (placeholder === t('O_AUCTION_END_DATE')) {
      handleAuctionEndDate(date)
    } else {
      handleDateChange(date)
    }
  }

  return (
    <Flatpickr
      //   className="flex flex-row-reverse border border-[#E9EDF9] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
      name='date'
      placeholder={placeholder ? placeholder : t('OFFERS_VALIDITY')}
      value={date}
      options={{
        minDate: 'today',
        dateFormat: 'd-m-Y'
      }}
      onChange={onChange}
    />
  )
}

export default ODatePicker
